import { createSlice } from "@reduxjs/toolkit";
import {
  getDashboardBookingDetails,
  getDashboardRatingHistory,
  getOverviewComparisonChart,
  getOverviewDashboard24_7_Chart,
  getOverviewDashboardChartDetails,
  getOverviewDashboardDetails,
  getOverviewDashboardSpaceDetails,
  getRatingDashboardDetails,
  ratingDashboardHistory,
} from "store/actions/dashboardSlice";

const data = {
  mainChartData: [
    {
      label: "2025-05-01",
      totalRevenue: 252.5,
      count: 7,
    },
    {
      label: "2025-05-02",
      totalRevenue: 222.5,
      count: 16,
    },
    {
      label: "2025-05-03",
      totalRevenue: 400,
      count: 14,
    },
    {
      label: "2025-05-04",
      totalRevenue: 0,
      count: 3,
    },
    {
      label: "2025-05-05",
      totalRevenue: 375,
      count: 8,
    },
    {
      label: "2025-05-06",
      totalRevenue: 480,
      count: 4,
    },
    {
      label: "2025-05-07",
      totalRevenue: 172.5,
      count: 4,
    },
    {
      label: "2025-05-08",
      totalRevenue: 107.5,
      count: 5,
    },
    {
      label: "2025-05-09",
      totalRevenue: 975,
      count: 26,
    },
    {
      label: "2025-05-10",
      totalRevenue: 55,
      count: 6,
    },
  ],
  comparisonChartData: [
    {
      label: "2025-04-20",
      totalRevenue: 30,
      count: 1,
    },
    {
      label: "2025-04-21",
      totalRevenue: 140,
      count: 6,
    },
    {
      label: "2025-04-22",
      totalRevenue: 2940,
      count: 13,
    },
    {
      label: "2025-04-23",
      totalRevenue: 60,
      count: 4,
    },
    {
      label: "2025-04-24",
      totalRevenue: 2772.76,
      count: 34,
    },
    {
      label: "2025-04-25",
      totalRevenue: 676,
      count: 12,
    },
    {
      label: "2025-04-26",
      totalRevenue: 1825,
      count: 8,
    },
    {
      label: "2025-04-27",
      totalRevenue: 0,
      count: 3,
    },
    {
      label: "2025-04-28",
      totalRevenue: 30,
      count: 4,
    },
    {
      label: "2025-04-29",
      totalRevenue: 842.5,
      count: 9,
    },
  ],
};

const initialState = {
  isLoading: false,
  loading: false,
  loading2: false,
  loading3: false,
  loading4: false,
  loading5: false,
  loading6: false,
  perPage: 100,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  ratingDashboardDetails: {},
  dashboardRatingHistory: {},
  overviewDashboard: {},
  overviewDashboardSpaceDetails: [],
  commonBookingTime: {},
  bookingDetails: {},
  exportReviewHistory: {},
  overviewDashboardChartData: [],
  comparisonChart:  [],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRatingDashboardDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRatingDashboardDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload || {};
          state.ratingDashboardDetails = data || {};
        }
      })
      .addCase(getRatingDashboardDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getDashboardRatingHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardRatingHistory.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};

        if (success) {
          state.dashboardRatingHistory = data || {};
        }
      })
      .addCase(getDashboardRatingHistory.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getOverviewDashboardDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOverviewDashboardDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};

        if (success) {
          state.overviewDashboard = data || {};
        }
      })
      .addCase(getOverviewDashboardDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getOverviewDashboardSpaceDetails.pending, (state) => {
        state.loading2 = true;
      })
      .addCase(getOverviewDashboardSpaceDetails.fulfilled, (state, action) => {
        state.loading2 = false;
        const { success, data } = action.payload || {};

        if (success) {
          state.overviewDashboardSpaceDetails = data || {};
        }
      })
      .addCase(getOverviewDashboardSpaceDetails.rejected, (state, action) => {
        state.loading2 = false;
      });

    builder
      .addCase(getOverviewDashboard24_7_Chart.pending, (state) => {
        state.loading3 = true;
      })
      .addCase(getOverviewDashboard24_7_Chart.fulfilled, (state, action) => {
        state.loading3 = false;
        const { success, data } = action.payload || {};

        if (success) {
          state.commonBookingTime = data || {};
        }
      })
      .addCase(getOverviewDashboard24_7_Chart.rejected, (state, action) => {
        state.loading3 = false;
      });

    builder
      .addCase(getDashboardBookingDetails.pending, (state) => {
        state.loading4 = true;
      })
      .addCase(getDashboardBookingDetails.fulfilled, (state, action) => {
        state.loading4 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.bookingDetails = data || {};
        }
      })
      .addCase(getDashboardBookingDetails.rejected, (state, action) => {
        state.loading4 = false;
      });

    builder
      .addCase(ratingDashboardHistory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(ratingDashboardHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.exportReviewHistory = data;
        }
      })
      .addCase(ratingDashboardHistory.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getOverviewDashboardChartDetails.pending, (state) => {
        state.loading5 = true;
      })
      .addCase(getOverviewDashboardChartDetails.fulfilled, (state, action) => {
        state.loading5 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.overviewDashboardChartData = data || [];
        }
      })
      .addCase(getOverviewDashboardChartDetails.rejected, (state, action) => {
        state.loading5 = false;
      });

    builder
      .addCase(getOverviewComparisonChart.pending, (state) => {
        state.loading6 = true;
        state.comparisonChart = [];
      })
      .addCase(getOverviewComparisonChart.fulfilled, (state, action) => {
        state.loading6 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.comparisonChart = data || [];
        }
      })
      .addCase(getOverviewComparisonChart.rejected, (state, action) => {
        state.loading6 = false;
      });
  },
});

export default dashboardSlice.reducer;
